import React from "react";

function AboutSystem() {
  const aboutItems = [
    { src: "media/images/About1.jpg", text: "DECADES OF EXPERIENCE" },
    { src: "media/images/About2.jpg", text: "CROSS DOMAIN EXPERTS" },
    { src: "media/images/About3.jpg", text: "TECHNOLOGY DRIVEN" },
    { src: "media/images/About4.jpg", text: "GLOBAL PRESENCE" },
    { src: "media/images/About5.jpg", text: "PARTNERSHIP APPROACH" },
    { src: "media/images/About6.jpg", text: "TECHNOLOGY EXPERTISE" },
  ];

  return (
    <div
      style={{
        backgroundImage: "url('media/images/aboutBackground1.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        minHeight: "100vh",
        padding: "50px 0",
      }}
    >
      <div className="container text-white">
        <div className="row text-center mb-5">
          <div className="col">
            <h1 className="mb-3">About</h1>
            <p style={{ textAlign: "justify", lineHeight: "2" }}>
              At IT Future Tech (IFT), we empower businesses by delivering
              end-to-end IT recruitment and technology solutions that drive
              innovation and accelerate growth. We specialize in building
              high-performance tech teams and crafting scalable, customized IT
              solutions tailored to modern business challenges. We pride
              ourselves on being more than a service provider – we’re a
              strategic partner.
            </p>
          </div>
        </div>

        <div className="row justify-content-center">
          {aboutItems.map((item, index) => (
            <div className="col-12 col-sm-6 col-md-4 mb-4" key={index}>
              <div className="position-relative text-white">
                <img
                  src={item.src}
                  alt={`About ${index + 1}`}
                  className="img-fluid rounded shadow"
                  style={{ width: "100%", height: "auto" }}
                />
                <h5
                  className="position-absolute top-50 start-50 translate-middle text-center fw-bold"
                  style={{ textShadow: "2px 2px 5px rgba(0,0,0,0.6)" }}
                >
                  {item.text}
                </h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AboutSystem;
